import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

interface ContactWithEmail {
  email: string;
}

export function emailExists(contacts: ContactWithEmail[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let isEmailExist = false;

    if (!control.value) {
      return null;
    }
    contacts.forEach((contact: ContactWithEmail) => {
      if (contact) {
        if (contact.email.toLowerCase() === control.value.toLowerCase()) {
          isEmailExist = true;
        }
      }
    });

    return !isEmailExist
      ? null
      : {
          validateEmail: { valid: false }
        };
  };
}
